import constants from '@/plugins/constants';

const DISCOVER_NOT_FOUND = 'not_found';
const WORK_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidWorkEmail(value) {
  const email = String(value || '').trim();
  if (!email) return false;
  return WORK_EMAIL_PATTERN.test(email);
}

export function getEmailNotFoundMessage() {
  return constants.AUTH.GENERIC_DISCOVER_ERROR;
}

export function getPasswordLoginErrorMessage() {
  return constants.AUTH.INVALID_EMAIL_OR_PASSWORD;
}

export function isDiscoverStatusNotFound(status) {
  return !status || status === DISCOVER_NOT_FOUND;
}

/** Matches SetNewPassword policy: 12+ chars, upper, lower, number, special (!@#$&*). */
export const PASSWORD_POLICY =
  /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{12,}/;

export function passwordMeetsPolicy(value) {
  return PASSWORD_POLICY.test(String(value || ''));
}

/** Unknown email → field error; known email + failed login → password error. */
export function getLocalLoginErrorMessage(emailUnknown) {
  return emailUnknown ? getEmailNotFoundMessage() : getPasswordLoginErrorMessage();
}
